import { render } from "./LoadingSkeletonDetail.vue?vue&type=template&id=3ed8ee6a&ts=true"
import script from "./LoadingSkeletonDetail.vue?vue&type=script&lang=ts"
export * from "./LoadingSkeletonDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__